module.exports = __webpack_public_path__ + "static/media/prop-2.27b80488.png";